// extracted by mini-css-extract-plugin
export default {"inputGroup":"qV_qW","inputGroup__input":"qV_qX"};